export default function editorContent() {
    const allParagraphs = document.querySelectorAll('.editor-content p');
    allParagraphs.forEach(paragraph => {
        const nearestEditorContent = paragraph.closest('.editor-content');
        if (nearestEditorContent && nearestEditorContent.hasAttribute('style')) {
            const inlineStyle = nearestEditorContent.getAttribute('style');
            paragraph.setAttribute('style', inlineStyle);
        }
    });
}